import React, { useEffect } from 'react'
import { Box, Button, HStack, Text } from '@chakra-ui/react'
import { getAuth } from 'firebase/auth'
import { useAuthState } from 'react-firebase-hooks/auth'

import { app } from '../../firebase'
import RegistrationPageTemplate from '../auth/RegistrationPageTemplate'
import EmailPasswordSignupForm from '../auth/EmailPasswordSignupForm'
import LoadingScreen from '../common/LoadingScreen'
import ErrorScreen from '../common/ErrorScreen'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import ReactGA from 'react-ga4'

const auth = getAuth(app)

const Signup: React.FC<{ setShowSidebar: (show: boolean) => void }> = ({
  setShowSidebar
}) => {
  ReactGA.send({
    hitType: 'pageview',
    page: window.location.pathname,
    name: 'Signup'
  })

  useEffect(() => {
    setShowSidebar(false)
  }, [])

  const [user, loading, error] = useAuthState(auth)
  const navigate = useNavigate()
  const location = useLocation()

  const queryParams = new URLSearchParams(location.search)
  const returnUrl = queryParams.get('returnUrl') || '/projects'
  const shouldSave = queryParams.get('save') === 'true'

  if (loading) {
    return <LoadingScreen />
  }

  if (error) {
    return <ErrorScreen error={error} />
  }

  if (user && !loading) {
    if (!user.emailVerified) {
      navigate('/verify-email')
    } else {
      navigate(returnUrl)
    }
  }

  return (
    <Box>
      <RegistrationPageTemplate
        headingText='Create an account'
        emailPasswordComponent={<EmailPasswordSignupForm returnUrl={returnUrl} />}
        helpComponent={
          <HStack spacing='1' justify='center'>
            <Text>Already have an account?</Text>
            <Link to={`/login${returnUrl ? `?returnUrl=${returnUrl}` : ''}`}>
              <Button variant='link' colorScheme='blue'>
                Log In
              </Button>
            </Link>
          </HStack>
        }
        returnUrl={returnUrl}
        shouldSave={shouldSave}
      />
    </Box>
  )
}

export default Signup
